import {Works, Welcome, Recipes, Meals} from '../../components';

function Home() {
    return (
        <div>
            <Welcome/>
            <Works/>
            <Recipes/>
            <Meals/>
        </div>
    )
}

export default Home;
